import { Controller } from "@hotwired/stimulus"

// The site header (shared/_header): on a phone, the search button (and the
// tab bar's Search) open a search row under the header; open menus
// (<details>) close on a click elsewhere or Escape.
export default class extends Controller {
  static targets = ["phoneSearch", "phoneInput"]

  connect() {
    this.outside = (event) => {
      document.querySelectorAll("details.hdr-me[open], details.adminbar-more[open]").forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false
      })
    }
    this.escape = (event) => {
      if (event.key === "Escape") document.querySelectorAll("details.hdr-me[open], details.adminbar-more[open]").forEach((menu) => { menu.open = false })
    }
    document.addEventListener("click", this.outside)
    document.addEventListener("keydown", this.escape)
  }

  disconnect() {
    document.removeEventListener("click", this.outside)
    document.removeEventListener("keydown", this.escape)
  }

  openSearch(event) {
    event.preventDefault()
    this.phoneSearchTarget.classList.add("is-open")
    window.scrollTo({ top: 0 })
    this.phoneInputTarget.focus()
  }
}
